import { render, staticRenderFns } from "./CicloUrgencia.vue?vue&type=template&id=97553b4c&"
import script from "./CicloUrgencia.vue?vue&type=script&lang=js&"
export * from "./CicloUrgencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports